module.exports = __webpack_public_path__ + "static/media/tkg.a31f38d1.jpg";